/**
 * Created by richardlovejoy on 2/16/17.
 */

import NumberDisplay from './NumberDisplay';
import AnimHelpers from '../../utils/misc/AnimHelpers';
import LogicCore from '../../logic/LogicCore';

/////////////////////////////////////////////////////////////////////////
// CONSTRUCTOR //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const BonusScoreMeter = function(game) {

  Phaser.Group.call(this, game);
  this.name = "BonusScoreMeter";

  this.init();
};

/////////////////////////////////////////////////////////////////////////
// CONSTANTS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////////////////
// MEMBERS ////////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
BonusScoreMeter.prototype = Object.assign( Object.create( Phaser.Group.prototype ), {

  constructor: BonusScoreMeter,


  init() {

    // post
    this.post = this.game.add.sprite(768, 300, 'skee', 'scorepost.png', this);

    // board
    this.board = this.game.add.sprite(669, 177, 'skee', 'scoreboard.png', this);

    // score
    this.scoreMeter = Object.create(NumberDisplay).init(this.game, this, 695, 201, 4, 0.86);

    // reflection
    this.topReflect = this.game.add.sprite(684, 196, 'skee', 'bigScoreReflect.png', this);

    // siren light
    this.siren = this.game.add.sprite(776, 143, 'skee', 'light_000.png', this);
    this.siren.anchor.set(0.5);
    this.siren.scale.set(0.718);
    this.sirenLoopCounter = 0;
    const animData = [
      {label: 'run', nameRoot: 'light_', frame1: 0, frameLast: 12}
    ];
    AnimHelpers.addAnimationData(this.siren, animData);

    // listen for bonus events
    this.game.logic.onSignalBonusEvent.add((bonusEvent, points) => {

      // play siren effect
      if (bonusEvent === LogicCore.BONUS_EVENT_2X_MULTIPLIER || bonusEvent === LogicCore.BONUS_EVENT_4X_MULTIPLIER) {
        this.playWinnerAnim(points);
      }
    });

    // listen for score changes
    this.game.logic.onSignalScoreChanged.add((newScore, pointsWon) => {

      // roll score meter
      //console.log(newScore, pointsWon);
      this.scoreMeter.setValue(0);
      this.scoreMeter.roll(pointsWon);

    });

    return this;
  },

  reset() {
    this.scoreMeter.setValue(0);
  },

  frameUpdate(dt) {

    this.scoreMeter.frameUpdate(dt);
  },

  playWinnerAnim(points) {

    // play siren
    this.sirenLoopCounter = 8;
    if (!this.siren.animations.currentAnim.isPlaying && points >= 200) {

      this.siren.play('run', 30, true);

      // stop after N loops
      this.siren.animations.currentAnim.onLoop.add(() => {

        if (--this.sirenLoopCounter === 0) {

          // stop siren and rest score
          this.siren.animations.currentAnim.onLoop.removeAll();
          this.siren.animations.currentAnim.stop();

        }

      });

    }



  }

});

export default BonusScoreMeter;



// WEBPACK FOOTER //
// ./app/src/display/meters/BonusScoreMeter.js